import { useAchWithdrawController } from "./AchWithdraw.controller";
import { AchWithdrawPresentation } from "./AchWithdraw.pres";

export const AchWithdrawConnector = () => {
  const controller = useAchWithdrawController();

  return <AchWithdrawPresentation {...controller} />;
};
